<div class="landing">
  <div class="wrapper">
    <img src="/assets/images/logo-full-white.svg" alt="Bulgari">
    @if (!authService.user){
    <button class="btn btn-primary" (click)="authService.login()">{{"LOGIN"|translate}}</button>
    }
    @else if(authService.user) {
    <button class="btn btn-primary" routerLink="/main">{{"ENTER"|translate}}</button>
    }
  </div>
</div>
